export enum BlastPlanTypeEnum {
	Monthly = 'monthly',
	Addon = 'addon',
}
